module.exports = __webpack_public_path__ + "img/Dantam Makeover 12.69765c17.jpg";